import { Formik } from "formik";
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/svg/logo.svg";
import PrimaryButton from "../../utils/buttons/PrimaryButton";
import execWebRequest from "../../utils/helpers/execWebRequest";
import MobileGatewayService from "../../services/mobile_auth.service";
import { useUserStore } from "../../store/user.store";
import { history } from "../..";
import { showBusyModal } from "./trybz_dashboard/_components/customModals/BusyModal";
import { loginSchema } from "../../utils/validationSchema";

export default function CustomerProfileLogin() {
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  const androidDownloadURL = searchParams.get("android");
  const iosDownloadURL = searchParams.get("ios");
  const customerRole = searchParams.get("type");
  const inviteId = searchParams.get("inviteId");

  function returnProfileType() {
    const customerProfiles = ["resident_invite", "tribe_member_invite"];
    const workerProfiles = ["security", "domestic_staff"];

    if (workerProfiles.includes(customerRole)) {
      return "worker";
    } else {
      return "customer";
    }
  }

  useEffect(() => {
    useUserStore.setState({
      androidDownloadURL: androidDownloadURL,
      iosDownloadURL: iosDownloadURL,
      type: returnProfileType(),
      inviteId: inviteId,
    });
  }, [androidDownloadURL, iosDownloadURL, customerRole, inviteId]);

  function loginActionHandler(payload) {
    return execWebRequest({
      execute: () =>
        MobileGatewayService.login(
          payload.email,
          payload.password,
          returnProfileType()
        ),
      onSuccess: async (loginResposne) => {
        showBusyModal();
        await MobileGatewayService.getUserData().then(async (response) => {
          useUserStore.setState({
            user: response,
          });
          if (loginResposne.hasSetPassword) {
            // if has set password and has completed profile
            if (response.profileCompleted) {
              return history.push("/customers/complete-profile/success");
            } else {
              return history.push("/customers/complete-profile");
            }
          } else {
            return await MobileGatewayService.sendOtp(
              response.phoneNumber
            ).then(() => {
              return history.push("/verify-otp");
            });
          }
        });
      },
    });
  }

  return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="container flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div className="d-flex justify-content-center h-100 align-items-center">
          <div className="authincation-content style-2 custom">
            <div className="row no-gutters">
              <div className="col-xl-12 tab-content">
                <div
                  id="sign-in"
                  className="auth-form auth-form-bg custom  rounded form-validation"
                >
                  {
                    <Formik
                      initialValues={{
                        email: "",
                        password: "",
                      }}
                      validationSchema={loginSchema}
                      validateOnChange={true}
                      onSubmit={(values) => loginActionHandler(values)}
                    >
                      {(formikProps) => (
                        <form
                          onSubmit={formikProps.handleSubmit}
                          className="form-validate "
                        >
                          <div className="d-flex align-items-center justify-content-center text-center tw-mb-8">
                            <img src={logo} alt="" width={100} />
                          </div>
                          <h3 className="text-center text-black tw-mb-4 tw-text-[28px]">
                            Login to your account
                          </h3>
                          <p className="text-center px-md-5 mb-2 tw-mx-auto tw-w-[90%] tw-text-base tw-text-secondary-dark-text">
                            Welcome Back! Fill the form below with valid
                            credentials to login.
                          </p>
                          <div className="form-group mb-3 px-md-4  ml-3">
                            <label className="mb-1" htmlFor="val-email">
                              <span className="font-w500 fs-14 tw-text-secondary-dark-text ">
                                Email
                              </span>
                            </label>
                            <div>
                              <input
                                type="email"
                                className="form-control rounded-pill border border-custom tw-h-[44px] tw-w-[90%] "
                                value={formikProps.values.email}
                                onChange={formikProps.handleChange}
                                placeholder="Type Your Email Address"
                                name="email"
                              />
                            </div>
                            {formikProps.errors.email && (
                              <div className="text-danger fs-12 mt-2">
                                {formikProps.errors.email}
                              </div>
                            )}
                          </div>
                          <div className="form-group mb-4 px-md-4 ml-3 ">
                            <label className="mb-1">
                              <span className="font-w500 fs-14 tw-text-secondary-dark-text">
                                Password
                              </span>
                            </label>
                            <input
                              type="password"
                              className="form-control rounded-pill border border-custom tw-h-[44px] tw-w-[90%] tw-max-w-[365px]"
                              value={formikProps.values.password}
                              name="password"
                              placeholder="Type Your Password"
                              onChange={formikProps.handleChange}
                            />
                            {formikProps.errors.password && (
                              <div className="text-danger fs-12 mt-2">
                                {formikProps.errors.password}
                              </div>
                            )}
                          </div>
                          <div className="text-center form-group mb-4 px-md-4 ml-3  tw-w-[89%]">
                            <PrimaryButton text={"Login"} />
                          </div>
                        </form>
                      )}
                    </Formik>
                  }
                  <div className="new-account text-center font-w500 px-md-4">
                    <p className="fs-14">
                      <Link className="text-primary" to="./forgot-password">
                        Forgot Password
                      </Link>
                    </p>
                  </div>
                  <div id="recaptcha-container"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
